(() => {
  const script = document.currentScript
  const personalizationLabel = script?.dataset.personalizationLabel || 'Personalization'

  const verboseKey = (key) => {
    const normalized = String(key || '').replace(/\s+/g, ' ').trim()
    return normalized.length > 48 || /^(please|enter|write|type|provide|upload)\b/i.test(normalized)
  }

  const normalizeAppCart = (root) => {
    root.querySelectorAll?.('ul.properties-key-value').forEach((list) => {
      const keys = [...list.querySelectorAll('.properties-key-value-key')]
      keys.forEach((node) => {
        const original = node.dataset.sjPropertyKey || node.textContent.trim()
        if (!verboseKey(original) || original.startsWith('_')) return
        node.dataset.sjPropertyKey = original
        node.textContent = personalizationLabel
      })
    })
  }

  const normalizeThemeCart = (root) => {
    root.querySelectorAll?.('.sj-cart-line__properties dt').forEach((node) => {
      const original = node.dataset.sjPropertyKey || node.textContent.trim()
      if (!verboseKey(original) || original.startsWith('_')) return
      node.dataset.sjPropertyKey = original
      node.textContent = personalizationLabel
    })
  }

  const normalize = (root = document) => {
    normalizeAppCart(root)
    normalizeThemeCart(root)
  }

  normalize()
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === 1) normalize(node.parentElement || document)
    }))
  }).observe(document.documentElement, { childList: true, subtree: true })
})()
